'use client';

import Button from '@ui/Button';
import getQualifiedImageUrl from '@utils/imageUrlProcessor';
import { size } from 'lodash-es';
import Image from 'next/image';
import React from 'react';
import { MdOutlineChevronLeft, MdOutlineChevronRight } from 'react-icons/md';
import { useSpringCarousel } from 'react-spring-carousel';
import VideoPlayer from '../VideoPlayer';

function PostVideos(props) {
  const { videoUrls = [] } = props;
  const showNavigation = size(videoUrls) > 1;
  const {
    carouselFragment,
    slideToPrevItem,
    slideToNextItem,
    getCurrentActiveItem,
  } = useSpringCarousel({
    items: videoUrls.map((video) => ({
      id: video,
      renderItem: (
        <div className="flex items-center justify-center w-full h-full select-none">
          <VideoPlayer
            src={video}
            // playing={true}
            className="object-contain"
            sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
          />
        </div>
      ),
    })),
    itemsPerSlide: 1,
    withLoop: true,
  });


  const handleNext = () => {
    slideToNextItem();
  };

  const handlePrev = () => {
    slideToPrevItem();
  };

  if (!videoUrls || videoUrls.length === 0) {
    console.log('Video Urls are required for PostVideos component');
    return null;  }

  return (
    <div className="relative w-full h-full flex items-center justify-start">
      <div className="`flex-1 overflow-hidden h-full w-full">
        {carouselFragment}
      </div>
      {showNavigation && (
        <>
          <div className="absolute top-1/2 left-1">
            <Button
              variant="icon"
              onClick={handlePrev}
              className={
                '!p-1 !bg-body-background opacity-60 hover:opacity-90'
              }>
              <MdOutlineChevronLeft className="w-6 h-6" />
            </Button>
          </div>
          <div className="absolute top-1/2 right-1">
            <Button
              variant="icon"
              onClick={handleNext}
              className={
                '!p-1 !bg-body-background opacity-60 hover:opacity-90'
              }>
              <MdOutlineChevronRight className="w-6 h-6" />
            </Button>
          </div>
        </>
      )}
    </div>
  );
}

export default PostVideos;
